import './polyfills';
import './sass/main.sass';

import React from 'react';
import { render } from 'react-dom';
import { isProd } from './app/components/config/config';
import App from './App';

const resolveSafeTarget = (rawTarget) => {
    try {
        const parsed = new URL(rawTarget, window.location.origin);
        if (parsed.origin !== window.location.origin) {
            return '/';
        }
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return '/';
    };
};

const translateLegacyHashbangUrl = () => {
    const { hash, search } = window.location;

    if (!hash.startsWith('#!')) {
        return;
    }

    const rawTarget = hash.slice(2);
    const safeTarget = resolveSafeTarget(rawTarget);
    window.location.replace(`${safeTarget}${search}`);
};

translateLegacyHashbangUrl();

/**
 * Disable react dev tools in production
 */
if (isProd) {
    if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line func-names
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () {};
    }
}

render(<App />, document.getElementById('app'));
